import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-tabview p-component" }
const _hoisted_2 = { class: "p-tabview-nav-container" }
const _hoisted_3 = {
  class: "p-tabview-nav-content",
  "data-pc-section": "navcontent"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  class: "p-tabview-nav-link p-tabview-header-action",
  role: "tab"
}
const _hoisted_6 = {
  key: 0,
  class: "p-tabview-ink-bar"
}
const _hoisted_7 = {
  class: "p-tabview-nav-link p-tabview-header-action",
  role: "tab"
}
const _hoisted_8 = { class: "p-tabview-panels" }
const _hoisted_9 = {
  key: 0,
  class: "p-tabview-panel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_DocumentClassTableColumnsSubView = _resolveComponent("DocumentClassTableColumnsSubView")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_TableForm = _resolveComponent("TableForm")!
  const _component_EntryDialog = _resolveComponent("EntryDialog")!
  const _component_DialogDelete = _resolveComponent("DialogDelete")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_BlockUI, { blocked: _ctx.loading }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_draggable, {
                modelValue: _ctx.documentClassTables,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.documentClassTables) = $event)),
                "item-key": "id",
                tag: "ul",
                class: "p-tabview-nav",
                onEnd: _ctx.onTabOrderChange,
                handle: ".drag-handle"
              }, {
                item: _withCtx(({ element: table, index }) => [
                  _createElementVNode("li", {
                    class: _normalizeClass(['p-tabview-header', { 'p-highlight': _ctx.activeTabIndex === index }]),
                    onClick: ($event: any) => (_ctx.activeTabIndex = index)
                  }, [
                    _createElementVNode("a", _hoisted_5, [
                      _cache[7] || (_cache[7] = _createElementVNode("i", {
                        class: "mdi mdi-reorder-horizontal drag-handle",
                        style: {"cursor":"move","margin-right":"8px"}
                      }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.getTranslatedDescription(table)) + "  ", 1),
                      _withDirectives(_createVNode(_component_Button, {
                        onClick: _withModifiers(($event: any) => (_ctx.openCurrentTableDialog(table)), ["stop"]),
                        icon: "mdi mdi-pencil-outline",
                        class: "p-button-rounded p-button-plain p-button-text reduceHeight"
                      }, null, 8, ["onClick"]), [
                        [_directive_tooltip, _ctx.$t('Squeeze.Locators.Edit')]
                      ]),
                      _withDirectives(_createVNode(_component_Button, {
                        onClick: _withModifiers(($event: any) => (_ctx.openDialogDeleteTable(table)), ["stop"]),
                        icon: "mdi mdi-delete-outline",
                        class: "p-button-rounded p-button-plain p-button-text reduceHeight"
                      }, null, 8, ["onClick"]), [
                        [_directive_tooltip, _ctx.$t('Squeeze.Validation.Buttons.Delete')]
                      ])
                    ]),
                    (_ctx.activeTabIndex === index)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_4)
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("li", {
                    class: "p-tabview-header",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onNewTabClick && _ctx.onNewTabClick(...args)))
                  }, [
                    _createElementVNode("a", _hoisted_7, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.DocumentClasses.NewTable')) + "  ", 1),
                      _createVNode(_component_Button, {
                        icon: "mdi mdi-plus",
                        class: "p-button-rounded p-button-plain p-button-text reduceHeight"
                      })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "onEnd"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentClassTables, (table, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: table.id
              }, [
                (_ctx.activeTabIndex === index)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_DocumentClassTableColumnsSubView, {
                        documentClassTables: _ctx.documentClassTables,
                        columns: table.columns,
                        locators: _ctx.locators,
                        tableId: table.id,
                        documentClassId: _ctx.documentClassId,
                        onGetDocumentClassTables: _cache[2] || (_cache[2] = (showLoadingAnimation) => { _ctx.getDocumentClassTables(_ctx.documentClassId, showLoadingAnimation) })
                      }, null, 8, ["documentClassTables", "columns", "locators", "tableId", "documentClassId"])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["blocked"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showCurrentTableDialog,
      onOnClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showCurrentTableDialog = false, _ctx.showErrorMessage= false, _ctx.isInvalid = true)),
      onOnConfirm: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveTable(true))),
      loading: _ctx.loadingSaveTable,
      message: _ctx.message,
      messageType: _ctx.messageType,
      headerText: _ctx.headerText
    }, {
      content: _withCtx(() => [
        _createVNode(_component_TableForm, {
          fieldEntry: _ctx.documentClassTableEntry,
          locators: _ctx.getLineLocators(_ctx.locators),
          tableField: true,
          showErrorMessage: _ctx.showErrorMessage,
          tablesWithLocators: _ctx.tablesWithLocators,
          allDocumentClasses: _ctx.allDocumentClasses,
          activeTableId: _ctx.activeTableId,
          documentTables: _ctx.documentTables,
          onUpdate: _ctx.onUpdateTable
        }, null, 8, ["fieldEntry", "locators", "showErrorMessage", "tablesWithLocators", "allDocumentClasses", "activeTableId", "documentTables", "onUpdate"])
      ]),
      _: 1
    }, 8, ["show", "loading", "message", "messageType", "headerText"]),
    _createVNode(_component_DialogDelete, {
      showDialog: _ctx.showDialogDeleteTable,
      onOnClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDialogDeleteTable = false)),
      onOnConfirm: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deleteTable(_ctx.documentClassTableEntry)))
    }, null, 8, ["showDialog"])
  ]))
}